import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  className?: string;
  scrollToId?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  scrollToId,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E8A87C] focus:ring-offset-[#FBF8F3]';
  const variants = {
    primary: 'bg-[#E8A87C] text-white hover:bg-[#D69065] shadow-lg shadow-[#E8A87C]/20',
    secondary: 'bg-white border-2 border-[#E8A87C] text-[#5C4A3A] hover:bg-[#FFF5F0]'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (scrollToId) {
      e.preventDefault();
      const element = document.getElementById(scrollToId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    } else {
      // Redirect to checkout URL
      window.location.href = 'https://tucambiohoy.online/cart/42869484585073:1';
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${baseStyles}
        ${variants[variant]}
        ${fullWidth ? 'w-full' : 'w-full sm:w-auto'}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-1">
      {children}
      <ArrowRight className="ml-2 h-5 w-5" data-id="element-2" />
    </motion.button>;
}